/**
 * Données publiées de la méthode (ticket T0e).
 *
 * Produit par `node scripts/generer-methode.mjs` à partir de `data/oit/` et
 * de `data/referentiel/metiers.json`. **Ne pas modifier à la main :** une page
 * méthode dont les nombres seraient recopiés divergerait du calcul réel au
 * premier changement de barème.
 */
export const REFERENTIEL = {
  "muMin": 0.09,
  "muMax": 0.7,
  "groupes": {
    "COMPTA": {
      "professions": 13,
      "moyenne": 0.5626201951037418,
      "pondere": true
    },
    "IT": {
      "professions": 15,
      "moyenne": 0.5495160080878692,
      "pondere": true
    },
    "ADMIN": {
      "professions": 21,
      "moyenne": 0.4903097363530647,
      "pondere": true
    },
    "RH": {
      "professions": 4,
      "moyenne": 0.4625,
      "pondere": false
    },
    "JURIDIQUE": {
      "professions": 5,
      "moyenne": 0.425288783530389,
      "pondere": true
    },
    "CREA": {
      "professions": 18,
      "moyenne": 0.3785349045835618,
      "pondere": true
    },
    "COMMERCIAL": {
      "professions": 31,
      "moyenne": 0.36521959545936994,
      "pondere": true
    },
    "DIRECTION": {
      "professions": 31,
      "moyenne": 0.36009881294187934,
      "pondere": true
    },
    "ENSEIGNEMENT": {
      "professions": 16,
      "moyenne": 0.3241233403092945,
      "pondere": true
    },
    "SANTE": {
      "professions": 41,
      "moyenne": 0.2339155886692479,
      "pondere": true
    },
    "TERRAIN": {
      "professions": 232,
      "moyenne": 0.1829285104118189,
      "pondere": true
    }
  },
  "metiersValides": 50,
  "referentielVersion": "1.1.0",
  "versions": [
    {
      "version": "1.0.0",
      "date": "10/08/2026",
      "texte": "Version initiale. Onze bases posées, reproduisant qualitativement le gradient de l'OIT sans en être dérivées."
    },
    {
      "version": "1.1.0",
      "date": "10/08/2026",
      "texte": "Les onze bases sont dérivées de l'indice de l'OIT 2025, profession par profession. Tous les scores changent ; les comparaisons avec la version précédente ne sont pas valides."
    },
    {
      "version": "1.2.0",
      "date": "12/08/2026",
      "texte": "Le volet niveau de maîtrise pose deux questions par axe au lieu d'une, sur les huit axes déjà en place. Le total passe de 16 à 32 points, et les frontières des quatre niveaux avec lui."
    },
    {
      "version": "1.3.0",
      "date": "31/08/2026",
      "texte": "Les bases sont désormais pondérées par l'emploi réel : une profession qui emploie deux millions de personnes ne pèse plus autant qu'une qui en emploie mille. Effectifs ILOSTAT, Côte d'Ivoire 2019 — une limite que nous écrivons, faute de données comparables sur toute la zone. Commercial et relation client recule de treize points, Métiers techniques et de terrain de six ; Juridique gagne cinq et Informatique et données quatre. Ressources humaines garde sa base non pondérée : les professions du groupe pour lesquelles aucun effectif fiable n'existe sont plus exposées que les autres, et la pondération y mesurerait ce manque plutôt que le métier. Un indice rendu avant cette date ne se compare pas à un indice rendu après."
    }
  ]
} as const;
